import React from 'react'
import './style.css'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import PageLayout from '../../components/PageLayout'
import { projectsConfig, getFeaturedProjects } from '../../config/projects'

export const Projects = () => {
  const getFilteredProjects = () => {
    return projectsConfig.projects.filter(project => project.display.showInPortfolio)
  }

  const handleProjectLaunch = (project) => {
    if (!project.deployment.url) return
    window.open(project.deployment.url, '_blank')
  }

  const filteredProjects = getFilteredProjects()
  const featuredProjects = getFeaturedProjects()

  return (
    <PageLayout
      title="Projects"
      description='Explore my collection of web applications, tools, and experiments'
      id='projects'
      className='projects'
    >

        <Container className='projects-container'>
          <Row className='mb-5 mt-3 pt-md-3'>
            <Col lg='12' className='text-center'>
              <Link to='/' className='back-link'>
                ← Back to Home
              </Link>
              <h1 className='display-4 mb-2'>Projects</h1>
              <p className='lead'>A collection of things I've built</p>
              <hr
                className='t_border my-4 mx-auto'
                style={{ width: '100px' }}
              />
            </Col>
          </Row>

          {featuredProjects.length > 0 && (
            <Row className='mb-5 featured-projects-grid'>
              <Col lg='12'>
                <h2 className='section-title mb-4'>Featured Work</h2>
                <Row>
                  {featuredProjects.map((project) => (
                    <Col
                      lg='12'
                      key={project.id}
                      className='mb-4'
                    >
                      <Card
                        className='project-card featured-card h-100'
                        onClick={() => handleProjectLaunch(project)}
                        style={{ cursor: project.deployment.url ? 'pointer' : 'default' }}
                      >
                        <Card.Body>
                          <Card.Title className='project-title'>
                            {project.title}
                          </Card.Title>
                          <Card.Text className='project-description'>
                            {project.description}
                          </Card.Text>
                          <p className='project-tech-stack'>
                            {project.technologies.join(' · ')}
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          )}

          <Row className='mb-5 all-projects-grid'>
            <Col lg='12'>
              <h2 className='section-title mb-4'>
                All Work ({filteredProjects.length})
              </h2>
              {filteredProjects.length === 0 ? (
                <div className='text-center py-5'>
                  <p className='text-muted'>
                    No projects match your current filter.
                  </p>
                </div>
              ) : (
                <Row>
                  {filteredProjects.map((project) => (
                    <Col
                      lg='12'
                      key={project.id}
                      className='mb-4'
                    >
                      <Card
                        className='project-card h-100'
                        onClick={() => handleProjectLaunch(project)}
                        style={{ cursor: project.deployment.url ? 'pointer' : 'default' }}
                      >
                        <Card.Body>
                          <Card.Title className='project-title'>
                            {project.title}
                          </Card.Title>
                          <Card.Text className='project-description'>
                            {project.description}
                          </Card.Text>
                          <p className='project-tech-stack'>
                            {project.technologies.join(' · ')}
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              )}
            </Col>
          </Row>
        </Container>
    </PageLayout>
  )
}
